<template>
  <div class="my-4 flex flex-row flex-wrap gap-x-2 gap-y-4 align-baseline">
    <div
      v-for="filter in selected"
      :key="`${filter.key}.${filter.value}`"
      class="flex items-center gap-x-2.5 min-w-[5rem] rounded-full bg-thm-light border border-gray-400 px-3 py-3.5 text-sm font-semibold hover:bg-inherit"
    >
      <span>{{ getLabel(filter) }}</span>

      <button @click.stop="remove(filter.key, filter.value)">
        <WebccIcon name="site/x" class="ml-1 h-4 w-4" />
      </button>
    </div>
  </div>

  <button
    class="text-left underline font-semibold flex gap-1 items-center"
    @click.stop="removeBatch()"
  >
    {{ $t(`${trPrefixCommon}removeAllFilters`) }}
  </button>
</template>

<script setup lang="ts">
import { camelCase, toString } from 'lodash-es'

const trPrefixCommon = 'www.common.'
const trPrefixFacets = 'www.facets.'
const trPrefixSearch = 'www.search.'

const model = defineModel<SearchState>({ required: true })

const confData = useConfdata()
const { toMoney } = useMoneyFormat(() => confData.currency)
const { t } = useI18n()

const { selected, remove, removeBatch } = useFilters(model)

function getLabel({ key, value, type }: FilterSelected) {
  if (type === 'range') {
    const [min, max] = value as PriceRangeValue
    const format = key === 'priceRange' ? toMoney : toString
    if (!min && !max) return ''
    if (min && !max) return `${t(`${trPrefixCommon}min`)}: ${format(min)}`
    if (!min && max) return `${t(`${trPrefixCommon}max`)}: ${format(max)}`
    return `${format(min)} - ${format(max)}`
  }

  const valueText = t(
    `${trPrefixSearch}${key}.${camelCase(toString(value))}` as TranslationKey,
  )
  return ['stepper', 'single'].includes(type)
    ? `${t(`${trPrefixFacets}${key}` as TranslationKey)}: ${valueText}`
    : valueText
}
</script>
